module.exports = __webpack_public_path__ + "img/電気回路_1_1_3.7cff92fe.png";